import angular from 'angular';
import scenes from './scenes';
import insuranceAppWorkbenchModal from './insuranceAppWorkbenchModal';

export default angular
  .module('insuranceAppWorkbench.scenes.insuranceAppWorkbenchModal', [scenes])
  .component('insuranceAppWorkbenchModal', insuranceAppWorkbenchModal).name;
